/* eslint-disable react-hooks/exhaustive-deps */
import { Route, Routes, useLocation, Navigate } from 'react-router';
import { Pages } from '../shared/pages';
import React, { useEffect } from 'react';
import { ManageAutoPay } from './ManageAutoPay';
import { CancelMembership } from './CancelMembership';
import { AutoPayConsent } from './AutoPayConsent';
import { AutoPayMinDue } from './AutoPayMinDue';
import { UpdateEmail } from './UpdateEmail';
import { ConfirmationPage } from './ConfirmationPage';
import { createEmptyInitialState, useGlobalState } from '../shared/state';
import { ErrorPage } from './ErrorPage';
import { ErrorType } from '../shared/types';

const Router: React.FC = () => {
  let location = useLocation();
  let locationState = { ...(location.state as { [prop: string]: any }) };
  const errorProps = { type: locationState?.type };
  const GwAutopayIneligibleErrorProps = { type: ErrorType.GW_AUTOPAY_INELIGIBLE_ERROR };

  const state = {
    sessionId: useGlobalState('sessionId')[0],
    selectedProduct: useGlobalState('selectedProduct')[0],
    selectedStoredMethod: useGlobalState('selectedStoredMethod')[0],
    selectedNewMethod: useGlobalState('selectedNewMethod')[0],
    clubCode: useGlobalState('clubCode')[0],
    newEnroll: useGlobalState('newEnroll')[0],
    emailFromWeb: useGlobalState('emailFromWeb')[0],
    confirmationVisited: useGlobalState('confirmationVisited')[0],
    confirmationDetails: useGlobalState('confirmationDetails')[0],
    emailOnFile: useGlobalState('emailOnFile')[0],
    transactionCheckMade: useGlobalState('transactionCheckMade')[0],
    billPlan: useGlobalState('billPlan')[0],
    memcid: useGlobalState('memcid')[0],
    discount: useGlobalState('discount')[0],
    brokerRegion: useGlobalState('brokerRegion')[0],
    renderCancel: useGlobalState('renderCancel')[0],
    referrer: useGlobalState('referrer')[0],
  };

  let baseUrl: string = Pages.ManageAutoPay;
  let { pathname } = location;
  let { search } = location;

  useEffect(() => {
    if (pathname === baseUrl && !state.sessionId) {
      const _state = {
        ...createEmptyInitialState(),
      };
      sessionStorage.setItem('manageAutopayState', JSON.stringify(_state));
    } else {
      sessionStorage.setItem('manageAutopayState', JSON.stringify({ ...state }));
    }
  }, [state, pathname]);

  if (
    (pathname.includes(Pages.Confirmation) && !search.includes('transactionId=')) ||
    (pathname.includes(Pages.UpdateEmail) && !search.includes('transactionId='))
  ) {
    return (
      <Routes>
        <Route Component={() => <Navigate to={baseUrl} replace />} />
        <Route path={baseUrl} Component={ManageAutoPay}></Route>
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path={Pages.ManageAutoPay} Component={ManageAutoPay} />
      <Route path={Pages.AutoPayConsent} Component={AutoPayConsent} />
      <Route path={Pages.AutoPayMinDue} Component={AutoPayMinDue} />
      <Route path={Pages.UpdateEmail} Component={UpdateEmail} />
      <Route path={Pages.Confirmation} Component={ConfirmationPage} />
      <Route path={Pages.CancelMembership} Component={CancelMembership} />
      <Route path={Pages.Error} Component={() => <ErrorPage {...errorProps} />} />
      <Route path={Pages.GwAutopayIneligibleError} Component={() => <ErrorPage {...GwAutopayIneligibleErrorProps} />} />
    </Routes>
  );
};

export default Router;
